import React, { useState } from "react";
import "./tourForm.css";
import { Row, Col, Spinner } from "reactstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../utils/config";

const TourForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    user_id: 0,
    tour_name: "",
    name: "",
    phonenumber: "",
    email: "",
    city: "",
    pax: "",
    tour_id: 0,
    coupon_code: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // console.log("Form data being sent:", formData);

    try {
      const res = await axios.post(
        `${BASE_URL}/send-mail`,
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (res.status !== 200) {
        setLoading(false);
        return alert(res.data.message);
      }

      navigate("/thank-you");
    } catch (err) {
      setLoading(false);
      alert("Something went wrong");
    }
  };

  return (
    <div className="tour-form-container">
      <form className="tour-form" onSubmit={handleSubmit}>
        <Row>
          <Col md="6" sm="12" className="mb-3">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Col>
          <Col md="6" sm="12" className="mb-3">
            <input
              type="text"
              name="tour_name"
              placeholder="Where you want to go"
              className="form-control"
              value={formData.tour_name}
              onChange={handleChange}
              required
            />
          </Col>
          <Col md="6" sm="12" className="mb-3">
            <input
              type="text"
              name="phonenumber"
              placeholder="Mobile"
              className="form-control"
              value={formData.phonenumber}
              onChange={handleChange}
              required
            />
          </Col>
          <Col md="6" sm="12" className="mb-3">
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Col>
          <Col md="6" sm="12" className="mb-3">
            <input
              type="text"
              name="city"
              placeholder="City"
              className="form-control"
              value={formData.city}
              onChange={handleChange}
              required
            />
          </Col>
          <Col md="6" sm="12" className="mb-3">
            <input
              type="number"
              name="pax"
              placeholder="Total Passengers"
              className="form-control"
              value={formData.pax}
              onChange={handleChange}
              required
              min="1"
            />
          </Col>
          <Col md="6" sm="12" className="mb-3">
            <input
              type="text"
              name="coupon_code"
              placeholder="Coupon Code"
              className="form-control"
              value={formData.coupon_code}
              onChange={handleChange}
            />
          </Col>
        </Row>
        <div className="btn-container">
          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TourForm;
